import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormGroup, Label, Row, Col, FormText } from 'reactstrap';
import { Field, change } from 'redux-form';
import { renderInput, required, Required, Optional, range, kana, email } from '../../helpers/formHelper';
import SchoolAutoSuggest from './SchoolAutoSuggest';
import { Student } from '../../helpers/propTypes';

class View extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  newStudentSelected() {
    const { formValues, editMode } = this.props;
    return formValues.student_id === 'new' || formValues.student_id === '' || editMode;
  }

  render() {
    const {
      formName, name, displays, onChangeBirthday, formValues, editMode, currentStudent, schools, emailRequired, showAllergy
    } = this.props;
    const getBirthday = (b) => {
      const date = new Date(b);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    };
    const showAllergyInfo = () => {
      const student = (
        formValues.parent_status !== undefined &&
        formValues.parent_status.student_statuses_attributes !== undefined &&
        formValues.parent_status.student_statuses_attributes[0].student_attributes !== undefined
      ) ? formValues.parent_status.student_statuses_attributes[0].student_attributes : formValues.student;
      return student !== undefined && student.allergy_flag !== undefined && student.allergy_flag === 'true';
    };

    return (
      <>
        <input name={`${name}[experience_id]`} type="hidden" value="7" />
        <Field name={`${name}[birthday]`} type="hidden" component="input" />
        {(this.newStudentSelected() && (
          <FormGroup>
            <Label>参加者氏名</Label>
            <Required />
            <Row>
              <Col style={{ paddingRight: '5px' }}>
                <Field
                  placeholder="姓"
                  id="student_last_name"
                  name={`${name}[last_name]`}
                  type="input"
                  component={renderInput}
                  validate={[required]}
                  disabled={editMode}
                />
              </Col>
              <Col style={{ paddingLeft: '5px' }}>
                <Field
                  placeholder="名"
                  id="student_first_name"
                  name={`${name}[first_name]`}
                  type="input"
                  component={renderInput}
                  validate={[required]}
                  disabled={editMode}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col style={{ paddingRight: '5px' }}>
                <Field
                  placeholder="セイ"
                  id="student_last_name_kana"
                  name={`${name}[last_name_kana]`}
                  type="input"
                  component={renderInput}
                  validate={[required, kana]}
                  disabled={editMode}
                />
              </Col>
              <Col style={{ paddingLeft: '5px' }}>
                <Field
                  placeholder="メイ"
                  id="student_first_name_kana"
                  name={`${name}[first_name_kana]`}
                  type="input"
                  component={renderInput}
                  validate={[required, kana]}
                  disabled={editMode}
                />
              </Col>
            </Row>
          </FormGroup>
        ))}
        <SchoolAutoSuggest
          formName={formName}
          schoolGradeInputName={`${name}[grade]`}
          schoolNameInputName={`${name}[school_name]`}
          gradeList={displays.gradeList}
          formValues={formValues}
          schools={schools}
        />
        <FormGroup>
          <Label>性別</Label>
          {this.newStudentSelected() ? (
            <>
              <Required />
              <br />
              <FormGroup inline check>
                <Field
                  type="radio"
                  value="male"
                  component={renderInput}
                  name={`${name}[gender]`}
                  label="男性"
                  id="student_gender_male"
                  validate={[required]}
                />{' '}
              </FormGroup>
              <FormGroup inline check>
                <Field
                  type="radio"
                  value="female"
                  component={renderInput}
                  name={`${name}[gender]`}
                  label="女性"
                  id="student_gender_female"
                  validate={[required]}
                />{' '}
              </FormGroup>
            </>
          ) : (
            <p style={{ fontSize: '14px', marginTop: '12px' }}>{currentStudent.gender === 'male' ? '男性' : '女性'}</p>
          )}
        </FormGroup>
        <FormGroup>
          <Label>生年月日</Label>
          {this.newStudentSelected() ? (
            <>
              <Required />
              <Row className="birthday">
                <Col style={{ paddingRight: '4.5px' }}>
                  <Field
                    id="birthday_year"
                    name="birthday_year"
                    type="select"
                    component={renderInput}
                    validate={[required]}
                    onChange={e => onChangeBirthday(formName, name, `${e.target.value}-${formValues.birthday_month}-${formValues.birthday_day}`)}
                  >
                    <option value="">年</option>
                    {displays.birthday.map(x => <option key={x} value={x}>{x}年</option>)}
                  </Field>
                </Col>
                <Col style={{ paddingLeft: '4.5px', paddingRight: '4.5px' }}>
                  <Field
                    id="birthday_month"
                    name="birthday_month"
                    type="select"
                    component={renderInput}
                    validate={[required]}
                    onChange={e => onChangeBirthday(`${formValues.birthday_year}-${e.target.value}-${formValues.birthday_day}`)}
                  >
                    <option value="">月</option>
                    {range(1, 13).map(x => <option key={x} value={x}>{x}月</option>)}
                  </Field>
                </Col>
                <Col style={{ paddingLeft: '4.5px' }}>
                  <Field
                    id="birthday_day"
                    name="birthday_day"
                    type="select"
                    component={renderInput}
                    validate={[required]}
                    onChange={e => onChangeBirthday(`${formValues.birthday_year}-${formValues.birthday_month}-${e.target.value}`)}
                  >
                    <option value="">日</option>
                    {range(1, 32).map(x => <option key={x} value={x}>{x}日</option>)}
                  </Field>
                </Col>
              </Row>
            </>
          ) : (
            <p style={{ fontSize: '14px', marginTop: '12px' }}>{getBirthday(currentStudent.birthday)}</p>
          )}
        </FormGroup>
        <FormGroup>
          <Label>参加者様携帯番号</Label>
          <Optional />
          <Field
            placeholder="携帯番号を入力"
            id="student_phone"
            name={`${name}[phone]`}
            type="input"
            component={renderInput}
            validate={[]}
          />
          <FormText>
            緊急時の連絡に使用することがございます。お持ちの方はご記入ください。
          </FormText>
        </FormGroup>
        <FormGroup>
          <Label htmlFor="location">参加者様メールアドレス</Label>
          {emailRequired ? <Required /> : <Optional /> }
          <Field
            placeholder="メールアドレスを入力"
            name={`${name}[email]`}
            type="input"
            component={renderInput}
            validate={emailRequired ? [email, required] : [email]}
          />
          <FormText color="danger">
            Googleメールアドレスを推奨いたします。
          </FormText>
        </FormGroup>
        {showAllergy && (
          <FormGroup>
            <Label>アレルギーの有無</Label>
            <Required />
            <br />
              <FormGroup inline check>
                <Field
                  type="radio"
                  value="false"
                  component={renderInput}
                  name={`${name}[allergy_flag]`}
                  label="なし"
                  id="student_allergy_flag_false"
                  validate={[required]}
                />{' '}
              </FormGroup>
              <FormGroup inline check>
              <Field
                type="radio"
                value="true"
                component={renderInput}
                name={`${name}[allergy_flag]`}
                label="あり"
                id="student_allergy_flag_true"
                validate={[required]}
              />{' '}
            </FormGroup>
            {showAllergyInfo() && (
              <Field
                placeholder="小麦、ナッツ、ソバ、乳製品、卵"
                id="student_allergy_info"
                name={`${name}[allergy_info]`}
                type="textarea"
                component={renderInput}
                validate={[required]}
              />)
            }
          </FormGroup>
        )}
        <FormGroup>
          <Label>服薬・その他健康面について</Label>
          <Optional />
          <Field
            placeholder="服薬・その他健康面について入力"
            id="student_allergy_other_health"
            name={`${name}[other_health]`}
            type="textarea"
            component={renderInput}
            validate={[]}
          />
        </FormGroup>
      </>
    );
  }
}

View.defaultProps = {
  editMode: false,
  formName: 'StudentForm',
  schools: null,
  emailRequired: false,
  showAllergy: true,
};

View.propTypes = {
  formName: PropTypes.string,
  name: PropTypes.string.isRequired,
  formValues: PropTypes.shape({
    authenticity_token: PropTypes.string,
  }).isRequired,
  onChangeBirthday: PropTypes.func.isRequired,
  displays: PropTypes.shape({
    students: PropTypes.arrayOf(Student),
    birthday: PropTypes.arrayOf(PropTypes.number).isRequired,
    gradeList: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]))).isRequired,
  }).isRequired,
  editMode: PropTypes.bool,
  currentStudent: Student.isRequired,
  schools: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    disabled: PropTypes.bool,
  })),
  emailRequired: PropTypes.bool,
  showAllergy: PropTypes.bool,
};

export default connect(state => ({
  currentStudent: state.student.currentStudent,
}), dispatch => ({
  onChangeBirthday: (formName, name, value) => dispatch(change(formName, `${name}[birthday]`, value)),
}))(View);
